import { ErrorFilled } from '@carbon/react/icons';
import { AtomField } from 'atoms/form-atoms';
import { TextInput, Layer } from '@carbon/react';
import { useAtomValue, useSetAtom } from 'jotai';
import { ReactNode } from 'react';

import style from './form.module.scss';

const TextField = ({
  id,
  labelText,
  fieldAtom,
  autoComplete,
  placeholder,
  required,
  serverError,
  onEdit,
}: {
  id: string;
  labelText: ReactNode;
  fieldAtom: AtomField<string | null> | AtomField<string>;
  autoComplete?: string;
  placeholder?: string;
  required?: boolean;
  // A 422 message the server keyed to this field.
  serverError?: string;
  onEdit?: () => void;
}) => {
  const field = useAtomValue(fieldAtom);
  const setField = useSetAtom(fieldAtom);
  const localError = !field.isValid && field.isDirty ? field.error : '';
  const error = localError || serverError || '';
  return (
    <Layer>
      <TextInput
        id={id}
        labelText={
          <label>
            {labelText}
            {required ? <span>(Required)</span> : ''}
            {!field.isValid || serverError ? (
              <span className={style.required}>
                <ErrorFilled />
              </span>
            ) : (
              ''
            )}
          </label>
        }
        size="md"
        className={style.textInput}
        value={field.value || ''}
        onChange={({ target: { value } }) => {
          setField(value);
          onEdit?.();
        }}
        invalid={!!error}
        invalidText={error}
        autoComplete={autoComplete}
        placeholder={placeholder}
      />
    </Layer>
  );
};

export { TextField };
